import { faImage, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';

import { Color } from '@/constants/color';
import AppContext from '@/contexts/appContext';
import { useUserChallengeImageLink } from '@/hooks/useUserChallengeImage/useUserChallengeImage';
import Alert from '@/ui/components/Alert';
import Button from '@/ui/components/Button';
import Spinner from '@/ui/components/Spinner';
import Tooltip from '@/ui/components/Tooltip';
import { CHALLENGES_VIEW_USER_CHALLENGE_IMAGE, hasPermission } from '@/utils/userPermission';

import type { Props } from './types';

const UserChallengeImage = ({ userChallengeImageId }: Props) => {
  const { permissions } = useContext(AppContext);
  const canViewImage = hasPermission({
    requiredPermission: CHALLENGES_VIEW_USER_CHALLENGE_IMAGE,
    permissions
  });

  const { data, isFetching, isError, refetch } = useUserChallengeImageLink({
    id: userChallengeImageId,
    enabled: false
  });

  if (isError) {
    return (
      <div>
        <Alert level={'error'}>
          <div>Error loading image</div>

          <Button className="mt-2" size="xs" onClick={() => refetch()}>
            Retry
          </Button>
        </Alert>
      </div>
    );
  }

  return isFetching ? (
    <Spinner />
  ) : data ? (
    <a href={data.url} target="_blank" rel="noreferrer">
      <img src={data.url} alt="User challenge image" />
      <p className="text-xs">
        <FontAwesomeIcon icon={faMagnifyingGlass} className="mr-1" />
        Click to view original
      </p>
    </a>
  ) : canViewImage ? (
    <Button color={Color.WHITE} size="xs" onClick={() => refetch()}>
      <FontAwesomeIcon icon={faImage} className="mr-2" />
      View Image
    </Button>
  ) : (
    <Tooltip tooltipContent="You do not have permission to view this image">
      <Button color={Color.WHITE} size="xs" disabled>
        <FontAwesomeIcon icon={faImage} className="mr-2" />
        View Image
      </Button>
    </Tooltip>
  );
};
export default React.memo(UserChallengeImage);
